import { t } from "@lingui/macro";
import { useCreateBillingPlanMutation } from "@src/__generated__/graphql";
import { Banner } from "@src/components/ui-kit";
import { onError } from "@src/utils/apollo";

interface CreateBillingPlanProps {
  projectId: string;
  onCreate?: () => void;
}

export const CreateBillingPlan = ({
  projectId,
  onCreate,
}: CreateBillingPlanProps) => {
  const [create, { loading }] = useCreateBillingPlanMutation({
    onCompleted() {
      onCreate?.();
    },
    ...onError(),
  });

  const onAction = () => create({ variables: { projectId } });

  return (
    <Banner
      size="sm"
      status="warning"
      px="3"
      py="2"
      title={t`You have just created a budget. Let’s create the invoicing plan`}
      primaryAction={{
        title: t`Add invoicing plan`,
        loading,
        onClick: onAction,
      }}
    />
  );
};
